import { render, staticRenderFns } from "./ServeTel.vue?vue&type=template&id=b6882f28&scoped=true"
import script from "./ServeTel.vue?vue&type=script&lang=js"
export * from "./ServeTel.vue?vue&type=script&lang=js"
import style0 from "./ServeTel.vue?vue&type=style&index=0&id=b6882f28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6882f28",
  null
  
)

export default component.exports